import { FC } from 'react'

import { FormNumberInput } from 'cng-common/features/form'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../../../configs'
import { ITranslationsProps, ITurnoverLargeFormatProps } from '../../models/turnoverProps'

import styles from './TurnoverEditMode.module.scss'

export const TurnoverLargeFormatEditMode: FC<
  ITranslationsProps & Omit<ITurnoverLargeFormatProps, 'isLargeFormatMode'>
> = ({ turnover, turnoverLabelKey = '' }) => {
  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <FormNumberInput
            formKey={PARTNER_BASIC_INFO_FORM_KEY}
            field={partnerBasicInfoFields.turnover}
            label={turnoverLabelKey}
            defaultValue={turnover}
          />
        </div>
      </div>
    </div>
  )
}
